/* import __COLOCATED_TEMPLATE__ from './general-gift-cards.hbs.js'; */
import Component from '@ember/component';
export default class GeneralGiftCards extends Component {}